module.exports = __webpack_public_path__ + "img/cu.a92d0d39.svg";